


















































































































































import { Component, Mixins } from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import AuthModule from '@/store/modules/Auth';
import ProfileModule from '@/store/modules/Profile';
import Table from '@/components/Table/Index.vue';
import ErrorHandleMixin from '@/mixins/ErrorHandle.vue';
import jwt_decode from 'jwt-decode';

@Component({
  components: {
    Table,
  },
})
export default class ProfileView extends Mixins(ErrorHandleMixin) {
  AuthInstance = getModule(AuthModule, this.$store);

  ProfileInstance = getModule(ProfileModule, this.$store);

  userId = this.AuthInstance.user._id;

  ipWhitelist = '';

  TableHead = [
    [
      {
        displayName: 'profile.date',
      },
      {
        displayName: 'profile.ip',
      },
    ],
  ];

  dataModel = {
    profile: {
      ...this.AuthInstance.user.profile,
    },
  }

  getToken = {}

  async created() {
    await this.ProfileInstance.FetchProfile();
    this.getToken = jwt_decode(this.AuthInstance.tokenRefresh);
    if (this.AuthInstance.user.ipWhitelist) {
      this.ipWhitelist = this.AuthInstance.user.ipWhitelist.join();
    }
  }

  async onSubmitInfo() {
    const { dataModel: { profile }, userId } = this;
    const data: any = {
      userId,
      profile,
    };
    if (this.ipWhitelist) {
      data.ipWhitelist = this.ipWhitelist.split(',');
    }
    const res = await this.ProfileInstance.UpdateProfile(data);
    this.checkError(res);
    this.ProfileInstance.FetchProfile();
  }
}
